// @ts-check

import { LiveMapIcons } from '../liveMapAssets';
import { COLLISION_RANKING_TIERS, MARKER_ANCHOR, MapView, Mappedin, MappedinNode, getVenue } from "@mappedin/mappedin-js";
import PermissionManager from '../../../../../infrastructure/js/utils/permissionManager';

/**
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").MapSearchResultsState} MapSearchResultsState
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").LivemapLocationDetailsResponseModel} LivemapLocationDetailsResponseModel
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").MapZoomLevel} MapZoomLevel
 * @typedef {import("@mappedin/mappedin-js/renderer/internal").SmartTooltip} SmartTooltip
 * 
 */



export class MapNormalViewLogic {


  /**
   * @param {any | undefined} sData
   * @param {MapView} mapView
   * @param {import('../Hooks/useHandleMapClick').MapNodeRef} refCurrentMapNode
   * @param {(venue: Mappedin, mapView: MapView) => void} recolorMap
   * @param {MapZoomLevel} zoomLevel
   */
  static process = (sData, mapView, refCurrentMapNode, recolorMap, zoomLevel) => {

    /** @type {{sections: LivemapLocationDetailsResponseModel[], stations: LivemapLocationDetailsResponseModel[]}} */
    let sFullStatus = sData.get('fullStatus');
    // console.log('sFullStatus ===> ', sFullStatus);

    if (!sFullStatus) {
      return;
    }


    let allLookupByName = new Map();
    sFullStatus.sections.forEach(section => {
      allLookupByName.set(section.name, section);
    });
    sFullStatus.stations.forEach(station => {
      allLookupByName.set(station.name, station);
    });


    renderMarkers(mapView, zoomLevel, allLookupByName, refCurrentMapNode);




  }



}




////////////////////////////////////////
// Helper functions.
//

/**
 * @param { MapView } mapView
 * @param { MapZoomLevel } zoomLevel
 * @param { Map<string, LivemapLocationDetailsResponseModel> } allLookupByName
 * @param { import('../Hooks/useHandleMapClick').MapNodeRef } refCurrentMapNode
*/
function renderMarkers(mapView, zoomLevel, allLookupByName, refCurrentMapNode) {
  console.log('renderMarkers ===> ');
  
  if (!mapView) {
    return;
  }
  
  let venue = mapView.venue;
  if (!venue) {
    return;
  }

  if (!allLookupByName) {
    return;
  }

  
  
  let excludeList = PermissionManager.getOrgPreferences().livemapExcludeList;
  let arrExcludeList = (excludeList) ? excludeList.split(',').map((/** @type {string} */ x) => x.trim()) : [];
  


  mapView.Markers.removeAll();

  ////////////////////////////////////
  // Render markers
  //
  venue.polygons.forEach((p) => {

    let externalId = p.externalId ? p.externalId : 'UNDEFINED';
    if (externalId === 'UNDEFINED') {
      return;
    }
    

    let location = allLookupByName.get(externalId);
    if (!location) {
      return;
    }

    if (p.entrances.length === 0) {
      return;
    }

    if (zoomLevel === "BIRDS_EYE") {
      return;
    }
    
    
    if (zoomLevel === "FULL_MAP") {
      
      ////////////////////////////////////////////////////////
      // In FULL_MAP mode, we only render top level nodes.
      // We render next level also if it has a direct parent in the exclude list.
      // 
      if (location.treeDepth > 1) {
        
        if (location.treePath && location.treePath.length > 0) {
          let directParent = location.treePath[0];
          if (!arrExcludeList.includes(directParent)) {
            return;
          }
        }
        
      }
      
      
    }

    
    // console.log('------ zzz Rendering marker ===> ', location.name);
    let node = p.entrances[0];
    
    let currentlySelectedNode = refCurrentMapNode?.current;
    if (currentlySelectedNode?.id === node.id) {
      // console.log(' ================== TOOLTIP DETECTED ! ===> ');
      return;
    }
    

    // console.log('------ Rendering marker ===> ', location.name);
    
    
    let markerHtml = null;
    
    if (zoomLevel === 'FULL_MAP') {
      markerHtml = getMarkerHtml_FULL_MAP(location);
      // markerHtml = getMarkerHtml_CLOSE_UP(location);
      // markerHtml = getMarkerHtml_CLOSE_UP__section(location);
    }

    if (zoomLevel === 'CLOSE_UP') {
      if (!(location.section)) {
        markerHtml = getMarkerHtml_CLOSE_UP(location);
      }
      if (location.section) {
        // console.log('SSSSSSSSSECTION!!! ===> ', location.name);
        markerHtml = getMarkerHtml_CLOSE_UP__section(location);
      }
    }
    
    
    if (!markerHtml) {
      return;
    }

    
    let rank = COLLISION_RANKING_TIERS.ALWAYS_VISIBLE;
    if (currentlySelectedNode !== null) {
      rank = COLLISION_RANKING_TIERS.OPTIONAL_MAXIMUM;
    }
    
    let marker = mapView.Markers.add(node, markerHtml, {
      anchor: MARKER_ANCHOR.RIGHT,
      // rank: COLLISION_RANKING_TIERS.ALWAYS_VISIBLE
      rank: rank
    });


  });

}





/**
 * @param {LivemapLocationDetailsResponseModel} location
 */
function getMarkerHtml_FULL_MAP(location) {
  
  if (location.alertsCounters.errors === 0 && location.alertsCounters.warnings === 0) {
    return null;
  }
  
  
  let renderErrorsHtml = () => {
    if (location.alertsCounters.errors === 0) {
      return '';
    }
    return `
    <div class="marker-errors">
      <div class="marker-errors__icon">${LiveMapIcons.liveMapMarkerErrorLarge}</div>
      <div class="marker-errors__count">${location.alertsCounters.errors}</div>
    </div>
    `;
  };
  
  let renderWarningsHtml = () => {
    if (location.alertsCounters.warnings === 0) {
      return '';
    }
    return `
    <div class="marker-warnings">
      <div class="marker-warnings__icon">${LiveMapIcons.liveMapMarkerWarningLarge}</div>
      <div class="marker-warnings__count">${location.alertsCounters.warnings}</div>
    </div>
    `;
  }
  
  
  return `
  <div class="marker-full-map">
    ${renderErrorsHtml()}
    ${renderWarningsHtml()}
  </div>
  `;
  
  
  // return `
  // <div class="marker-full-map">
  //   <div class="marker-errors">
  //     <div class="marker-errors__icon">${LiveMapIcons.liveMapMarkerErrorLarge}</div>
  //     <div class="marker-errors__count">7</div>
  //   </div>
  // </div>
  // `;
  
  // return `
  // <div class="marker-full-map">
  //   <div class="marker-warnings">
  //     <div class="marker-warnings__icon">${LiveMapIcons.liveMapMarkerWarningLarge}</div>
  //     <div class="marker-warnings__count">17</div>
  //   </div>
  // </div>
  // `;
  
  
  
}

/**
 * @param {LivemapLocationDetailsResponseModel} location
 */
function getMarkerHtml_CLOSE_UP(location) {
  
  
  let renderErrorsHtml = () => {
    if (location.alertsCounters.errors === 0) {
      return '';
    }
    return `
    <div class="marker-errors">
      <div class="marker-errors__icon">${LiveMapIcons.liveMapMarkerErrorSmall}</div>
      <div class="marker-errors__count">${location.alertsCounters.errors}</div>
    </div>
    `;
  };
  
  let renderWarningsHtml = () => {
    // if (location.alertsCounters.errors > 0) {
    //   return '';
    // }
    if (location.alertsCounters.warnings === 0) {
      return '';
    }
    return `
    <div class="marker-warnings">
      <div class="marker-warnings__icon">${LiveMapIcons.liveMapMarkerWarningSmall}</div>
      <div class="marker-warnings__count">${location.alertsCounters.warnings}</div>
    </div>
    `;
  }
  
  let renderTitleHtml = () => {
    let freezerClass = location.freezer ? 'freezer' : '';
    return `
    <div class="marker-title ${freezerClass}">
      ${location.name}
    </div>
    `;
  }
  
  
  return `
  <div class="marker-close-up">
    ${renderTitleHtml()}
    ${renderErrorsHtml()}
    ${renderWarningsHtml()}
  </div>
  `;
  
  
  
  // return `
  // <div class="marker-close-up">
  //   <div class="marker-title">
  //     ${location.name}
  //   </div>
  //   <div class="marker-errors">
  //     <div class="marker-errors__icon">${LiveMapIcons.liveMapMarkerErrorSmall}</div>
  //     <div class="marker-errors__count">12</div>
  //   </div>
  //   <div class="marker-warnings">
  //     <div class="marker-warnings__icon">${LiveMapIcons.liveMapMarkerWarningSmall}</div>
  //     <div class="marker-warnings__count">17</div>
  //   </div>
  // </div>
  // `;
  
  
}

/**
 * @param {LivemapLocationDetailsResponseModel} location
 */
function getMarkerHtml_CLOSE_UP__section(location) {

  return `
  <div class="marker-close-up-section">
    <div class="marker-title">
      ${location.name}
    </div>
  </div>
  `;
  
  
}














